// extracted by mini-css-extract-plugin
export default {"footer":"c-g_eg"};